import { useState, useEffect } from "react";
import { Menu, X, Scissors } from "lucide-react";
import { CONTACT } from "@/data/site";

export const Navbar = () => {
  const [open, setOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 20);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const links = [
    { href: "#services", label: "Services" },
    { href: "#portfolio", label: "Work" },
    { href: "#watch", label: "Watch" },
    { href: "#reviews", label: "Reviews" },
    { href: "#book", label: "Book" },
  ];

  return (
    <header
      data-testid="site-header"
      className={`fixed top-0 inset-x-0 z-50 transition-all duration-300 ${
        scrolled ? "bg-black/80 backdrop-blur-xl border-b border-[#27272A]" : "bg-transparent"
      }`}
    >
      <div className="container-x flex items-center justify-between py-4">
        <a href="#top" className="flex items-center gap-3" data-testid="logo-link">
          <div className="w-10 h-10 rounded-md bg-black flex items-center justify-center overflow-hidden border border-[#27272A]">
            <svg viewBox="0 0 64 64" className="w-7 h-7">
              <path d="M38 10 L18 32 H30 L26 54 L46 32 H34 Z" fill="#E63946"/>
            </svg>
          </div>
          <div className="leading-tight">
            <div className="font-display text-xl text-white tracking-wide">BLENDZ.JAY</div>
            <div className="text-[10px] uppercase tracking-[0.25em] text-dim">Lancaster · PA</div>
          </div>
        </a>

        <nav className="hidden md:flex items-center gap-8">
          {links.map((l) => (
            <a
              key={l.href}
              href={l.href}
              data-testid={`nav-${l.label.toLowerCase()}`}
              className="text-sm uppercase tracking-[0.2em] text-dim hover:text-white transition-colors"
            >
              {l.label}
            </a>
          ))}
          <a href="#book" className="btn-accent" data-testid="nav-book-cta">
            <Scissors size={16} /> Book Now
          </a>
        </nav>

        <button
          className="md:hidden text-white"
          onClick={() => setOpen((v) => !v)}
          data-testid="mobile-menu-toggle"
          aria-label="Toggle menu"
        >
          {open ? <X size={24} /> : <Menu size={24} />}
        </button>
      </div>

      {open && (
        <div className="md:hidden bg-black/95 border-t border-[#27272A]" data-testid="mobile-menu">
          <div className="container-x py-6 flex flex-col gap-5">
            {links.map((l) => (
              <a
                key={l.href}
                href={l.href}
                onClick={() => setOpen(false)}
                className="text-sm uppercase tracking-[0.2em] text-dim hover:text-white"
                data-testid={`mobile-nav-${l.label.toLowerCase()}`}
              >
                {l.label}
              </a>
            ))}
            <a href="#book" onClick={() => setOpen(false)} className="btn-accent w-fit" data-testid="mobile-book-cta">
              Book Now
            </a>
          </div>
        </div>
      )}
    </header>
  );
};
